export const recs = {
  channel: {
    Android: "53",
    default: "53",
    iOS: "54",
  },
};
